const agreement = v => v === 1 || v === true;

export default agreement;
